var React = require('react');

function ChevronIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.67628 12.5713L2 6.829L7.67628 1.08672","stroke":"currentColor","strokeWidth":"1.5"}));
}

ChevronIcon.defaultProps = {"width":"100%","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 9 14","fill":"none"};

module.exports = ChevronIcon;

ChevronIcon.default = ChevronIcon;
